import { LogicalExpressionParser } from "../../../logic/LogicalExpressionParser";
import { isNull } from "../../../util/TypeUtil";
import Content from "../Content";
import ContentFactory from "../ContentFactory";
import ContentTypes from "../ContentTypes";

/**
* ConversationTopicContent.js
* 
* Created on 17-okt-2013, 12:16:41
*
* @author Ivo Swartjes for Ranj
**/
export default class ConversationTopicContent extends Content {
    constructor(languagePack, contentID, topicLabel, topicDescription, topicNewCondition, topicDisabledCondition, label) {
        super(ConversationTopicContent.NAME, ContentTypes.TYPE_CONVERSATION_TOPIC, label, languagePack, contentID);

        this._topicLabel = topicLabel;
        this._topicDescription = topicDescription;
    }

    remove() {
        this.removeLanguagePackText(ConversationTopicContent.TOPIC_LABEL);
        this.removeLanguagePackText(ConversationTopicContent.TOPIC_DESCRIPTION_LABEL);
        super.remove();
    }

    getTopicLabel() {
        return this.getLanguagePackText(ConversationTopicContent.TOPIC_LABEL);
    }

    setTopicLabel(value) {
        return this.setLanguagePackText(ConversationTopicContent.TOPIC_LABEL, value);
    }

    getTopicDescription() {
        return this.getLanguagePackText(ConversationTopicContent.TOPIC_DESCRIPTION_LABEL);
    }

    setTopicDescription(value) {
        return this.setLanguagePackText(ConversationTopicContent.TOPIC_DESCRIPTION_LABEL, value);
    }

    getTopicNewCondition() {
        const topicNewCondition = this.getLanguagePackContent(ConversationTopicContent.TOPIC_NEW_CONDITION_LABEL, ContentTypes.TYPE_CONVERSATION_TOPIC);
        return topicNewCondition;
    }

    setTopicNewCondition(value) {
        return this.setLanguagePackContent(ConversationTopicContent.TOPIC_NEW_CONDITION_LABEL, ContentTypes.TYPE_CONVERSATION_TOPIC, value);
    }

    getTopicDisabledCondition() {
        return this.getLanguagePackContent(ConversationTopicContent.TOPIC_DISABLED_CONDITION_LABEL, ContentTypes.TYPE_CONVERSATION_TOPIC);
    }

    setTopicDisabledCondition(value) {
        return this.setLanguagePackContent(ConversationTopicContent.TOPIC_DISABLED_CONDITION_LABEL, ContentTypes.TYPE_CONVERSATION_TOPIC, value);
    }

    // ------------
    convertToObject() {
        const parser = new LogicalExpressionParser();
        const object = this.getObject([]);
        object[ConversationTopicContent.TOPIC_NEW_CONDITION_LABEL] = (!isNull(this.getTopicNewCondition()) ? parser.serialize(this.getTopicNewCondition()) : null);
        object[ConversationTopicContent.TOPIC_DISABLED_CONDITION_LABEL] = (!isNull(this.getTopicDisabledCondition()) ? parser.serialize(this.getTopicDisabledCondition()) : null);
        return object;
    }

    setPropertiesFromObject(object) {
        super.setPropertiesFromObject(object);
        const parser = new LogicalExpressionParser();

        this.topicNewCondition = (!isNull(object[ConversationTopicContent.TOPIC_NEW_CONDITION_LABEL]) ? parser.parse(object[ConversationTopicContent.TOPIC_NEW_CONDITION_LABEL]) : null);
        this.topicDisabledCondition = (!isNull(object[ConversationTopicContent.TOPIC_DISABLED_CONDITION_LABEL]) ? parser.parse(object[ConversationTopicContent.TOPIC_DISABLED_CONDITION_LABEL]) : null);
    }

    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_CONVERSATION_TOPIC, this._languagePack);
        clone.setContentID(this.getContentID());
        clone.setTopicLabel(this.getTopicLabel());
        clone.setTopicDescription(this.getTopicDescription());
        clone.setTopicNewCondition(this.getTopicNewCondition());
        clone.setTopicDisabledCondition(this.getTopicDisabledCondition());

        return clone;
    }
}

ConversationTopicContent.NAME = "Conversation Topic";
ConversationTopicContent.TYPE = "engConversationTopicContent";
ConversationTopicContent.TOPIC_LABEL = "topic";
ConversationTopicContent.TOPIC_DESCRIPTION_LABEL = "topicDescription";
ConversationTopicContent.TOPIC_NEW_CONDITION_LABEL = "topicNewCondition";
ConversationTopicContent.TOPIC_DISABLED_CONDITION_LABEL = "topicDisabledCondition";


